type SessionRuntimeShape = {
  readonly status?: string | null | undefined;
  readonly activeTurnId?: string | null | undefined;
};

function hasNonEmptyTurnId(activeTurnId: string | null | undefined): boolean {
  return typeof activeTurnId === "string" && activeTurnId.trim().length > 0;
}

export function isSessionActivelyRunning(session: SessionRuntimeShape | null | undefined): boolean {
  return session?.status === "running" && hasNonEmptyTurnId(session.activeTurnId);
}

export function isSessionTransitioning(session: SessionRuntimeShape | null | undefined): boolean {
  if (!session) return false;
  if (session.status === "connecting") return true;
  return session.status === "running" && !hasNonEmptyTurnId(session.activeTurnId);
}

export function isSessionFailed(session: SessionRuntimeShape | null | undefined): boolean {
  return session?.status === "error";
}
